import { Brand } from "./brand"
import { type PartnerInfo } from "./types"

/**
 * Deliberately nav-less. This is a landing-page system, not a website — there
 * is no navigation between the hub and the per-agent pages, so the header
 * carries the partner's brand and the two ways to reach them, nothing else.
 */
export function SiteHeader({ partner }: { partner: PartnerInfo }) {
  return (
    <header className="w-full px-4 py-5 sm:px-8">
      <div className="mx-auto flex w-full max-w-5xl items-center justify-between gap-4">
        {/* The brand slot takes whatever's left and truncates. Partner names run
            much longer than the design's "Haven" — without this the actions
            squeeze until "Sign in" breaks across two lines on a phone. */}
        <Brand partner={partner} className="min-w-0 truncate" />
        <div className="flex shrink-0 items-center gap-2">
          <a
            href={partner.sign_in_url}
            className="text-lp-muted hover:bg-lp-fg/5 hover:text-lp-fg inline-flex h-10 items-center rounded-full px-4 text-sm font-medium whitespace-nowrap transition-colors select-none sm:px-5"
          >
            Sign in
          </a>
          {partner.support_email && (
            <a
              href={`mailto:${partner.support_email}`}
              className="border-lp-border text-lp-fg hover:border-lp-border-strong inline-flex h-10 items-center rounded-full border bg-white px-4 text-sm font-medium whitespace-nowrap transition-colors select-none sm:px-5"
            >
              Contact us
            </a>
          )}
        </div>
      </div>
    </header>
  )
}
